export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      default: () => ({
        empty: '⬜',
        partial: '🟨',
        full: '✅'
      })
    }
  },

  data () {
    return {
      states: ['none', 'full'],
    }
  },

  mounted() {
	if(this.vModel === 'partial') {
		this.states = ['none', 'partial', 'full'];
	}
	this.$refs.checkbox.indeterminate = this.checkedState === 'indeterminate';
  },

  computed: {
    vModel: {
      get () {
        return this.context.model ? this.context.model : this.context.value
      },
      set (val) {
        this.context.model = val
        this.context.rootEmit('input', val)
      }
    },
    currentIndex () {
      return this.states.indexOf(this.vModel)
    },
    currentIcon () {
      if (this.vModel === 'none') return this.icons.empty
      if (this.vModel === 'partial') return this.icons.partial
      if (this.vModel === 'full') return this.icons.full
      return this.icons.empty
    },
	checkedState() {
		let state = false;
		if(this.vModel === 'full') {
			state = true;
		} else if(this.vModel === 'partial') {
			state = 'indeterminate';
		}
		return state;
	}
  },

  methods: {
    toggle () {
      const nextIndex = (this.currentIndex + 1) % this.states.length
      this.vModel = this.states[nextIndex]
    }
  },
  watch: {
	checkedState(val) {
		this.$refs.checkbox.indeterminate = val === 'indeterminate';
	}
  }
}
